import React, { useEffect, useState } from 'react';
import DropDown from './UI/DropDown';
import LangSelect from './UI/LangSelect';
import { useGetAvailableLanguages, useSelectLanguage } from '../../hooks/global/Languages';
import { useTranslation } from 'react-i18next';
import { Form, Button } from "react-bootstrap";
import LoadingSpinner from '../global/LoadingSpinner';
import { getObjectValue } from '../../helpers/general';
import { error, success } from '../../hooks/global/ToastAlert';
import { useGetVendorId } from '../../hooks/global/User';
import moment from 'moment';
import { useSentInvitations } from '../../hooks/invitations/Invitations';

const EmailForm = ({ profiles, groups }) => {

  const { t } = useTranslation();
  const vendorId = useGetVendorId();
  const availableLanguages = useGetAvailableLanguages();
  const { selectTextByLanguage } = useSelectLanguage();

  const { mutate: sendInvitations, isLoading: isSending, isError: isUpdateError, data:result } = useSentInvitations();

  const [lng, setLng] = useState(availableLanguages[0]);
  const [selected, setSelected] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [timeToSend, setTimeToSend] = useState(0);
  const [checkedReviewProfile, setCheckedReviewProfile] = useState();
  const [inputError, setInputError] = useState();


  const validateRules = [
    { index: 'firstName', regex: /^.+$/s },
    { index: 'lastName', regex: /^.+$/s },
    { index: 'email', regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }
  ];

  const handleSelect = (item) => {
    setSelected(item);
  }

  const handleLangSelect = (language) => {
    setLng(language);
  }

  const validateInvitation = () => {
    let err = {};;


    validateRules.forEach(item => {
      const value = getObjectValue({ firstName: firstName, lastName: lastName, email: email }, item.index)
      if (!item.regex.test(value))
        err[item.index] = true;
    });

    setInputError(err);
    if (selected && Object.keys(err).length === 0) {
      return true;
    } else { Object.keys(err).length>0 ?   error(t("err.sInv")):error(t("toast.one"));
      return false;
    }
  };

  const resetFormOnSuccess = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setOrderNumber("");
    setTimeToSend(0);
  };

  const submitInvitation = (e) => {
    e.preventDefault();

    const reviewProfile =  selected?.groupName? false : true;
    if (validateInvitation()) {
      let payload = {
        customerEmail: email,
        customerName: firstName,
        customerSurname: lastName,
        orderNumber: orderNumber,
        vendorId: vendorId,
        reviewProfile: reviewProfile,
        purchaseDateUtcMs: moment().format("x"),
        sendAfterHours: timeToSend,
        sendProductReviewAfterHours: timeToSend,
        language: lng,
        test:true, //TODO: remove this line in production
        products: [],
      };

      if (reviewProfile) {
        payload.profileId = selected.id;
      }

      if (!reviewProfile) {
        //products.filter((product) => selectedProducts.includes(product.id)).map((product) => {
            let productPayload = {
              sourceId: selected.source_id,
              name: selected.name,
              imgUrl: selected.imgUrl,
              group: groups.filter((group) => group.name === selected.groupName)[0].name,
              tags: selected.tags,
              nameMultilanguage: selected.name,
            };
            payload.products.push(productPayload);
         // });
      }

      sendInvitations({ data: payload, message: t("toast.inv"), show:false });
    }
  };

  useEffect(() => {
    if(result && (result?.result?.[0]?.status ==='sent' || result?.result?.[0]?.status ==='scheduled')){
      success(t("toast.inv"));
      resetFormOnSuccess();
      result.result = null;
    } else if(result && result?.result?.[0].status ==='error'){
      if(result.result[0]?.t)
        error(t(result.result[0].t));
      else
        error(t("err.sInv") + ': ' + result.result[0].reject_reason);
  
      result.result = null;
    }
  }, [result]);



  return (
    <div>
      <h2>{t("admin.inv.data")}</h2>

      <p>{t("admin.inv.addA")}
        <div className="dropdown-and-lang">
          <DropDown value={selected} profiles={profiles} groups={groups} onSelect={handleSelect} />
          <LangSelect value={lng} onSelect={handleLangSelect} />
        </div>
      </p>

      <Form className="manualInvite clearfix">
        <p className="row">
          <Form.Group className={`col-md-6 editMe-field editMe-fieldName ${inputError?.firstName ? "has-error has-feedback" : ""}`} controlId="fromBasicName" >
            <Form.Control name="name" placeholder={t("admin.prize.name")} tabIndex="1" value={firstName} type="text" onChange={(e) => setFirstName(e.target.value)} />
            {inputError?.firstName && <span className="help-block validation-message small">{t('err.req')}</span>}
          </Form.Group>

          <Form.Group className={`col-md-6 editMe-field editMe-fieldLastName ${inputError?.lastName ? "has-error has-feedback" : ""}`} controlId="fromBasicLastName">
            <Form.Control name="surname" placeholder={t("admin.prize.lastname")} tabIndex="2" value={lastName} type="text" onChange={(e) => setLastName(e.target.value)} />
            {inputError?.lastName && <span className="help-block validation-message small">{t('err.req')}</span>}
          </Form.Group>
        </p>
        <p className="row">
          <Form.Group className={`editMe-field editMe-fieldEmail ${inputError?.email ? "has-error has-feedback" : ""}`} controlId="formBasicEmail">
            <Form.Control name="email" placeholder={t("login.email")} tabIndex="3" value={email} type="email" onChange={(e) => setEmail(e.target.value)} />
            {inputError?.lastName && <span className="help-block validation-message small">{t('err.req')}</span>}
          </Form.Group>
        </p>

        <p className="row">
          <Form.Group className="editMe-field editMe-fieldOrder" controlId="formBasicordernumber">
            <Form.Control name="orderNumber" placeholder={t("admin.inv.num")} value={orderNumber} tabIndex="4" type="text" onChange={(e) => setOrderNumber(e.target.value)} />
          </Form.Group>

        </p>

        <div className="margin-top-30 clearfix">
          <div className="delayWrap clearfix">
            <p>{t("admin.inv.time")}
            <div className="delay">
              <div className="form-group send-time">
                <div className="" style={{alignContent:"center"}}>
                  {t("admin.inv.getIn")}
                </div>
                <div className="">
                  <Form.Control type="number" name="invitationDelay" value={timeToSend} onChange={(e) => setTimeToSend(e.target.value)} />
                </div>
                <div className="" style={{alignContent:"center"}}>{t("admin.inv.h")}.</div>
              </div>
            </div>
            </p>
          </div>
          <div className="">
            {!isSending ? (<Button type="submit" className="btn btn-default btn-send" title={t("common.send")} onClick={(e) => submitInvitation(e)} >
              {t("common.send")}
            </Button>) : (<LoadingSpinner style={{ margin: '25px auto 15px' }} />)}
          </div>
        </div>

      </Form>

    </div>
  );
};

export default EmailForm;
